import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { Portal } from '../../utils/Portal';

import DrawDate from './DrawDate';
import Balls from './Balls';
import Loader from "../loader/Loader";

function LatestResults({ usertimezone }) {
    const url = 'site/api/latest-results';
    const [date, setDate] = useState();
    const [numbers, setNumbers] = useState([[]]);
    const [lotteryType, setLotteryType] = useState('lottery');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getLatestDraw();
    }, []);

    function getLatestDraw() {
        axios.get(url).then((response) => {
            setDate(response.data.date);
            setNumbers(response.data.numbers);
            setLotteryType(response.data.lottery_type);
            setLoading(false);
        });
    }

    function getContent() {
        return <div>
            <Portal id="draw-date">
                <DrawDate date={date} timezone={usertimezone} />
            </Portal>
            <Balls numbers={numbers} lotteryType={lotteryType} />
        </div>
    }
    return <Loader isLoading={loading} elementToShow={getContent()} />;
}

export default LatestResults;
